module.exports = __webpack_public_path__ + "media/icons/offer-details-dostawcze-b771c0a1.png";